import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate, Link } from "react-router-dom";
import { loginUser } from "../services/user_services.tsx";
import { useAuth } from "../services/authContext_service.tsx";
import { Visibility, VisibilityOff } from "@mui/icons-material";

// slike
const background = require("../assets/login/background.png");
const loginFrame = require("../assets/login/login_form.png");
const girl = require("../assets/login/queen.png");
const coins = require("../assets/login/coins_in_the_group.png");
const coins1 = require("../assets/login/coins_in_the_group1.png");
const loginButton = require("../assets/login/login_button.png");
const loginCoin = require("../assets/login/login_coin.png");

const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    const images = [background, loginFrame, girl, coins, coins1, loginButton, loginCoin];

    let loaded = 0;

    images.forEach((src) => {
      const img = new Image();
      img.src = src;

      const done = () => {
        loaded++;
        if (loaded === images.length) {
          setImagesLoaded(true);
        }
      };

      img.onload = done;
      img.onerror = done;
    });
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    setError(null);

    try {
      const response = await loginUser(formData);
      localStorage.setItem("accessToken", response.access);
      localStorage.setItem("refreshToken", response.refresh);
      login();
      navigate("/home");
    } catch (err: any) {
      setError(err.message || "Login failed.");
    }
  };

  if (loading || !imagesLoaded) {
    return (
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "black",
        }}
      >
        <CircularProgress size={80} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <img
        src={background}
        alt="Background"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "200px",
          zIndex: 2,
        }}
      >
        <img src={coins1} alt="coins1" style={{ width: "100%", opacity: 0.5 }} />
      </Box>

      <Box
        sx={{
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "30%",
          zIndex: 1,
          display: { xs: "none", md: "block" },
        }}
      >
        <img src={coins} alt="coins" style={{ width: "100%", opacity: 0.5 }} />
      </Box>

      <Box
        sx={{
          position: "absolute",
          right: 0,
          bottom: 0,
          height: "70%",
          zIndex: 1,
          display: { xs: "none", md: "block" },
        }}
      >
        <img src={girl} alt="girl" style={{ height: "100%", opacity: 0.8 }} />
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "53%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
          width: "700px",
          maxWidth: "90vw",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-25%",
            left: "63%",
            transform: "translateX(-50%)",
            width: "100%",
            zIndex: 0,
            pointerEvents: "none",
            display: { xs: "none", md: "block" },
          }}
        >
          <img src={loginCoin} alt="coin" style={{ width: "100%", opacity: 0.2 }} />
        </Box>

        <Box
          sx={{
            display: "block",
            position: "relative",
            zIndex: 2,
            "@media (max-width:725px)": {
              display: "none",
            },
          }}
        >
          <img src={loginFrame} alt="frame" style={{ width: "100%" }} />
        </Box>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            position: "absolute",
            top: "62%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "65%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pointerEvents: "none",
            zIndex: 2,
          }}
        >
          <TextField
            fullWidth
            name="username"
            value={formData.username}
            onChange={handleChange}
            sx={{
              mb: 1,
              pointerEvents: "auto",
              input: {
                color: "#ccc",
                textAlign: "left",
                fontFamily: "'Cinzel', serif",
                fontSize: "16px",
                letterSpacing: "0.5px",
                paddingLeft: "12px",
              },
              "& .MuiOutlinedInput-root": {
                height: "60px",
                borderRadius: "12px",
                background: "#1a0026",
                "& fieldset": {
                  border: "2px solid #555",
                },
                "&:hover fieldset": {
                  borderColor: "#ff00cc",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ff00cc",
                  boxShadow: "0 0 12px #ff00cc",
                },
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #1a0026 inset",
                  WebkitTextFillColor: "#ccc",
                  transition: "background-color 5000s ease-in-out 0s",
                },
              },
            }}
          />

          <TextField
            fullWidth
            name="password"
            type={showPassword ? "text" : "password"}
            autoComplete="new-password"
            value={formData.password}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={togglePasswordVisibility}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              mb: 1.5,
              pointerEvents: "auto",
              input: {
                color: "#ccc",
                textAlign: "left",
                fontFamily: "'Cinzel', serif",
                fontSize: "16px",
                letterSpacing: "0.5px",
                paddingLeft: "12px",
              },
              "& .MuiOutlinedInput-root": {
                height: "60px",
                borderRadius: "12px",
                background: "#1a0026",
                "& fieldset": {
                  border: "2px solid #555",
                },
                "&:hover fieldset": {
                  borderColor: "#ff00cc",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ff00cc",
                  boxShadow: "0 0 12px #ff00cc",
                },
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #1a0026 inset",
                  WebkitTextFillColor: "#ccc",
                  transition: "background-color 5000s ease-in-out 0s",
                },
              },
            }}
          />

          <Box
            onClick={handleSubmit}
            sx={{
              width: "70%",
              cursor: "pointer",
              pointerEvents: "auto",
              mt: -0.5,
              "&:hover": {
                transform: "scale(1.05)",
                filter: "drop-shadow(0 0 15px #ff00cc)",
              },
            }}
          >
            <img src={loginButton} alt="login" style={{ width: "100%" }} />
          </Box>
        </Box>

        <Box
          sx={{
            position: "absolute",
            width: "100%",
            textAlign: "center",
            bottom: {
              xs: error ? "-200px" : "-140px",
              sm: error ? "-150px" : "-110px",
              md: "-80px",
            },
          }}
        >
          {error && (
            <Typography sx={{ color: "#ff4d6d", mb: 1 }}>
              {error}
            </Typography>
          )}

          <Typography sx={{ color: "#fff" }}>
            Don't have an account?{" "}
            <Link to="/register" style={{ color: "#ff66ff", fontWeight: "bold" }}>
              Register
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;